// extracted by mini-css-extract-plugin
export default {"btn":"iPtjt","menuItem":"NMmY9"};